import axios from 'axios'
import { detect } from 'detect-browser'
import { handleAccessToken } from '../js/script'
import { accessToken } from './auth'
//@ts-ignore
export const token = (() => {
  const storedToken = window.localStorage.getItem('aboutAccessToken')
  if (storedToken === null || storedToken === undefined) {
    return null // 여기서 명시적으로 null 반환
  }
  try {
    return JSON.parse(storedToken) // storedToken이 있을 때만 JSON 파싱
  } catch (error) {
    console.error('Failed to parse token:', error)
    return null
  }
})()
export const getToken = () => {
  const storedToken = window.localStorage.getItem('aboutAccessToken')
  if (storedToken === null || storedToken === undefined) {
    return null // 여기서 명시적으로 null 반환
  }
  try {
    return JSON.parse(storedToken) // storedToken이 있을 때만 JSON 파싱
  } catch (error) {
    console.error('Failed to parse token:', error)
    return null
  }
}
//https://dev-token-api.aboutfishing.kr
//https://api.aboutfishing.kr

// token 사용
const base = process.env.REACT_APP_ABOUT_FISHING
export const client = axios.create({
  baseURL: base,
  timeout: 10000,
  headers: {
    'X-AF-API-KEY': 'U2tG7fhugMc7scwwkHJYRLkgRRuCytUWXw399DMwWKfBY2KWz2QGYdqSSet9DzAQ',
  },
  responseType: 'json',
})

export const aboutUserClient = axios.create({
  baseURL: base,
  timeout: 10000,
  headers: {
    'X-AF-API-KEY': 'U2tG7fhugMc7scwwkHJYRLkgRRuCytUWXw399DMwWKfBY2KWz2QGYdqSSet9DzAQ',
    Authorization: `Bearer ${token}`,
  },
  responseType: 'json',
})

aboutUserClient.interceptors.request.use(
  (config) => {
    const token = getToken()
    if (token) {
      // const expiredDate = getParsedLocalStorageItem('expired').b;
      // const expiredTokenTime = getParsedLocalStorageItem('expired').a;
      // if(new Date()< expiredDate+expiredTokenTime){
      //   //sifb ouyt
      // }

      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

// // 응답 인터셉터 추가
aboutUserClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401: {
          const refresh = window.localStorage.getItem('aboutRefreshToken')
          const os = detect()?.os
          if (refresh && os) handleAccessToken(refresh, os)
          if (token === null) {
            window.localStorage.removeItem('aboutRefreshToken')
            window.localStorage.removeItem('aboutAccessToken')
            window.localStorage.removeItem('accessToken')
            window.localStorage.removeItem('lastAccessTokenUpdateTime')
            window.location.href = '/'
            setTimeout(() => {
              window.location.reload()
            }, 300)
          }
          break
        }
        default:
          break
      }
    } else {
      console.error('네트워크 오류 또는 기타 예외 발생')
    }
    return Promise.reject(error)
  }
)

//인증 코드 받기
export async function postSendCode(phoneNumber: string) {
  return await client.post(`/auth/send-certification-code`, {
    mobilePhone: phoneNumber,
  })
}

//인증 코드 검증
export async function postVerifyCode(phoneNumber: string, messageId: string, code: string) {
  return await client.post(`/auth/verify-certification-code`, {
    mobilePhone: phoneNumber,
    messageId: messageId,
    codeFromClient: code,
  })
}

//로그인
export async function postLogin(mobilePhone: string, verificationCheckCode: string, osType: string) {
  return await client.post(`/auth/login-by-mobile`, {
    mobilePhone: mobilePhone,
    verificationCheckCode: verificationCheckCode,
    osType: osType,
    from: 'shop',
  })
}

//약관 목록
export async function getPolicies() {
  return await client.get(`/auth/user-policies-to-agree`)
}

//약관 동의 저장
export async function postUserPolicies(item: any, token: string) {
  return await aboutUserClient.post(
    `/auth/user-policies`,
    {
      policyAgreements: item,
    },
    { headers: { Authorization: `Bearer ${token}` } }
  )
}

//회원가입
export async function postCreateUser(
  email: string,
  nickName: string,
  phone: string,
  recommenderId: string | null,
  verificationCheckCode: string | null,
  osType: string,
  image: string,
  isMobilePhoneVerified: boolean,
  loginType: string,
  internalUserId: string
) {
  return await client.post(`/auth/create-user`, {
    nation: '+82',
    internalUserId: internalUserId,
    email: email,
    nickName: nickName,
    profileImage: image,
    loginType: loginType,
    mobilePhone: phone,
    isMobilePhoneVerified: isMobilePhoneVerified,
    recommenderId: recommenderId,
    verificationCheckCode: verificationCheckCode,
    osType: osType,
  })
}

//닉네임 중복 확인
export async function postCheckNickname(nickname: string) {
  return await client.post(`/auth/check-nick-name`, {
    nickName: nickname,
  })
}

//이메일 중복 확인
export async function postCheckEmail(email: string) {
  return await client.post(`/auth/check-Email`, {
    email: email,
  })
}

//token리프레쉬
export async function postRefresh(refreshToken: string, osType: any) {
  return await client.post(`/auth/refresh`, {
    refreshToken: refreshToken,
    osType: osType,
    from: 'shop',
  })
}
//프로필 이미지 가져오기
export async function getProfileImage() {
  if (accessToken) {
    return await aboutUserClient.get(`/auth/profile-images`)
  } else {
    return await client.get(`/auth/profile-images`)
  }
}

//프로필 이미지 업로드
export async function postProfileImage(formData: any) {
  if (accessToken) {
    return await aboutUserClient.post(`/auth/upload-profile-image`, formData)
  } else {
    return await client.post(`/auth/upload-profile-image`, formData)
  }
}
//회원 수정
export async function postUpdateUser(
  email: string,
  nickName: string,
  profileImage: string,
  biography: string,
  website: string,
  mobilePhone: string,
  verificationCheckCode: string
) {
  return await aboutUserClient.post(`/auth/update-user`, {
    email: email,
    internalUserId: email,
    nickName: nickName,
    profileImage: profileImage,
    biography,
    website,
    mobilePhone,
    verificationCheckCode,
  })
}
// 피싱코인 적립금전환
export async function postAccumulation(coin: number, memberNo: number) {
  return await aboutUserClient.post(`/shopby-support/coin/exchange-accumulation`, {
    coin,
    memberNo,
  })
}

export async function postMarketingConsent(memberNo: number) {
  return await aboutUserClient.post('/shopby-support/coin/accumulate-by-marketing-consent', {
    memberNo,
  })
}

//로그아웃
export async function postLogout(userId: number) {
  return await aboutUserClient.post(`/auth/logout`, {
    userId: userId,
  })
}

//피싱코인 조회
export async function postSupportCoin(type: string) {
  return await aboutUserClient.post(`/shopby-support/coin/coins`, {
    type: type,
    offset: 0,
    limit: 100,
  })
}

//추천인 확인
export async function postFindUser(nickName: string) {
  return await client.post(`/auth/find-user`, {
    userId: '',
    nickName: nickName,
  })
}

//카카오톡으로 인증번호 받기
export async function postKaKao(phone: any) {
  return await client.post(`/auth/send-certification-code-kakao`, {
    mobilePhone: phone,
  })
}

//로그인 없이 폰 번호 변경
export async function postChangeMobile(
  mobilePhone: string,
  email: string,
  newMobilePhone: string,
  verificationCheckCode: string
) {
  return await client.post(`/auth/change-mobile-phone`, {
    mobilePhone: mobilePhone,
    email: email,
    newMobilePhone: newMobilePhone,
    verificationCheckCode: verificationCheckCode,
  })
}

//탈퇴 사유
export async function getWithdrawReason() {
  return await aboutUserClient.get(`/auth/withdraw-reasons`)
}

//회원 탈퇴
export async function postWithdraw(userId: number, reason: string, reasonDetail: string) {
  return await aboutUserClient.post(`/auth/withdraw`, {
    userId: userId,
    reason: reason,
    reasonDetail: reasonDetail,
  })
}

// 인플루언서 리뷰
export async function getHomeReview() {
  return await client.get(`/shopby-support/home-reviews`)
}

// 유저 알림 상세
export async function getUserNotiSetting() {
  return await aboutUserClient.get(`/auth/user-notification-setting`)
}

// 유저 알림 상세 헤더 필요
export async function getUserNotiSettingHeader(token: string) {
  return await aboutUserClient.get(`/auth/user-notification-setting`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}

// 유저 알림 동의 비동의
export async function postUserNotiSetting(isMarketing: boolean) {
  return await aboutUserClient.post(`/auth/user-notification-setting`, {
    isMarketing: isMarketing,
  })
}

//샵바이 토큰 기준 유저정보 검색
export async function getUserProfile(token: string) {
  return await aboutUserClient.get(`/shopby-support/profile?token=${token}`)
}

//3만원 지급 회원가입시 바로
export async function postDirectWelcome(token: string) {
  return await aboutUserClient.post(
    `/shopby-support/coin/accumulate-by-welcome`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
}

//3만원 지급 여부
export async function getWelcome() {
  return await aboutUserClient.get(`/shopby-support/coin/accumulation-by-welcome`)
}

//3만원 지급
export async function postWelcome() {
  return await aboutUserClient.post(`/shopby-support/coin/accumulate-by-welcome`)
}

//프로필 조회
export async function getFishingProfile() {
  return await aboutUserClient.get(`/auth/profile`)
}

// Access token 검증 api
export async function getVerifyAccessToken(token: string) {
  if (!token) {
    throw new Error('Access token is required')
  }
  return await aboutUserClient.get(`/auth-util/verify/access-token`, {
    params: {
      accessToken: token,
    },
  })
}

export async function getMenu() {
  return await client.get(`/shopby-support/home-components`)
}

//팝업
export async function getPopup() {
  return await client.get(`/shopby-support/shopping-ads-modal`)
}

//2만원 적립금 마케팅동의
export async function getMarketingAgreeAcc(memberNo: number) {
  return await aboutUserClient.post(`/shopby-support/coin/accumulate-by-marketing-consent`, {
    memberNo: memberNo,
  })
}

//마이쇼핑 하단 이미지
export async function getMyshoppingBanner() {
  return await client.get(`/shopby-support/my-shopping-banners`)
}

//유저 알림 상세
export async function getUserNoti() {
  return await aboutUserClient.get(`/auth/user-notification-setting`)
}

//프로필 조회 헤더 필요
export async function getUserNotiHeader(token: string) {
  return await aboutUserClient.get(`/auth/user-notification-setting`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}

// festival
export async function getFestivals(urlPath: string) {
  return await client.get(`/shopby-support/festivals/${urlPath}`)
}

export async function getFestivalsList() {
  return await client.get(`/shopby-support/ongoing-festivals`)
}

// 적립금 타입 지급
export async function postFestivalTypeAcc(memberId: number, festivalId: string, type: string) {
  return await aboutUserClient.post(`/shopby-support/coin/accumulate-by-type`, {
    memberNo: memberId,
    festivalId: festivalId,
    accumulationType: type,
  })
}

// 페스티벌 적립금 확인하기
export async function getFestivalAcc() {
  return await aboutUserClient.get(`/shopby-support/coin/accumulation-by-festival?type=festival-20000`)
}

// 페스티벌 타입 적립금 확인하기
export async function getFestivalTypeAcc(id: string, type: string) {
  return await aboutUserClient.get(
    `/shopby-support/coin/accumulation-by-type?festivalId=${id}&accumulationType=${type}`
  )
}

// 2%적립금
export async function postMypayAcc(memberNo: number, orderOptionNo: number, acc: number) {
  return await aboutUserClient.post(`/shopby-support/coin/accumulate-by-my-pay`, {
    memberNo: memberNo,
    orderOptionNo: orderOptionNo,
    accumulationAmt: acc,
  })
}

//카카오 소셜 로그인
export async function postKakaoSocialLogin(internalUserId: string, accessToken: string, phoneNumber: string) {
  return await client.post(`/auth/login-by-kakao`, {
    internalUserId,
    accessToken,
    phoneNumber,
  })
}

//랜덤 닉네임 얻기
export async function getRandomNickname() {
  return await client.get(`/auth/random-nickname`)
}

// 카카오 인증번호 발송
export async function postKakaoCode(phoneNumber: string) {
  return await client.post(`/auth/send-certification-code-kakao`, {
    mobilePhone: phoneNumber,
  })
}

// 카카오 소셜 연결
export async function postKakaoSocialConnect(internalUserId: string, loginType: string) {
  return await aboutUserClient.post(`/auth/social-user-create`, {
    internalUserId: internalUserId,
    loginType: loginType,
  })
}

//카카오 소셜 해제
export async function postKakaoSocialDisconnect(loginType: string) {
  return await aboutUserClient.post(`/auth/social-user-delete`, {
    loginType: loginType,
  })
}

// 휴대폰 번호 점유인증을 위해 자신의 계정 확인
export async function postCheckAccount(phoneNumber: string, email: string) {
  return await client.post(`/auth/search-user-by-email-and-mobile`, {
    mobilePhone: phoneNumber,
    email: email,
  })
}
